export const FEDERATED_EMAIL_RESULT_PAGE_SIZE = 30;

export function getFederatedEmailResultCount({
	rawCount,
	exactCount,
	hasNextPage,
	pageSize = FEDERATED_EMAIL_RESULT_PAGE_SIZE,
}: {
	rawCount: number;
	exactCount: number;
	hasNextPage: boolean;
	pageSize?: number;
}): { count: number | null; hasMore: boolean } {
	if (rawCount === 0 && exactCount === 0) {
		return { count: null, hasMore: false };
	}

	if (!hasNextPage) {
		return { count: exactCount, hasMore: false };
	}

	return {
		count: Math.ceil(rawCount / pageSize) * pageSize,
		hasMore: true,
	};
}
